import React from 'react';

import i18n from '../i18n';
import ActionList from './ActionList';
import ActionListItem from './ActionListItem';
import { Input } from './Input';
import PrebookingDurationPage from './PrebookingDurationPage';
import ChatWizardHeader from '../components/ChatWizardHeader';
import { StyledContainer, StyledContent } from '../components/basicComponents';
import { getDurationTitle } from '../utils/timeUtils';

const getTitle = (mode) => {
  if (mode === 'list') {
    return i18n('od_details_title');
  }
  if (mode === 'subject') {
    return i18n('od_details_subject_subtitle');
  }
  return '';
};

const OdDetailsPage = props => {
  if (props.mode === 'subject') {
    return (
      <StyledContainer>
        <ChatWizardHeader
          noPadding
          title={getTitle(props.mode)}
        />
        <StyledContent>
          <div style={props.style}>
            <div style={{ marginBottom: 20 }}>
              <Input
                data-test='odDetailsSubject'
                type='text'
                placeholder={i18n('subject_placeholder')}
                value={props.subject || ''}
                maxLength='50'
                onChange={value => props.onChangeSubject && props.onChangeSubject(value)}
                active={true}
              />
            </div>
          </div>
        </StyledContent>
        {props.children}
      </StyledContainer>
    );
  }

  if (props.mode === 'duration') {
    return (
      <StyledContainer>
        <PrebookingDurationPage
          style={props.style}
          duration={props.duration}
          presence={props.presence}
          selectedContractId={props.selectedContractId}
          onDurationChanged={minutes => {
            props.onDurationChanged && props.onDurationChanged(minutes);
          }}
        />
        {props.children}
      </StyledContainer>
    );
  }

  return (
    <StyledContainer>
      <ChatWizardHeader
        noPadding
        title={getTitle(props.mode)}
      />
      <StyledContent>
        <div style={props.style}>
          <ActionList>
            <ActionListItem
              title={i18n('subject')}
              subtitle={props.subject}
              onClick={() => props.onModeChange('subject')}
            />
            <ActionListItem
              title={i18n('estimated_duration')}
              subtitle={props.duration ? getDurationTitle(props.duration) : ''}
              onClick={() => props.onModeChange('duration')}
            />
          </ActionList>
        </div>
      </StyledContent>
      {props.children}
    </StyledContainer>
  );
};

export default OdDetailsPage;


